const DEFAULT_TITLE = 'DreamVinyl';
const DEFAULT_DESCRIPTION =
  'Marketplace de vinilo, noticias, comunidad y Grooves. Compra, vende y conecta con otros coleccionistas.';

/**
 * Actualiza título y meta básicas (pestaña del navegador; crawlers usan HTML estático u og-noticia).
 */
export function setPageMeta({ title, description } = {}) {
  if (typeof document === 'undefined') return;
  const t = title?.trim() || DEFAULT_TITLE;
  document.title = t;

  const desc = description?.trim() || DEFAULT_DESCRIPTION;
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'description');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', desc);
}

export function resetPageMeta() {
  setPageMeta({});
}
